var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-slide"},[_c('div',{staticClass:"slide"},_vm._l((_vm.images),function(image,index){return _c('img',{key:index,staticClass:"image",class:{censored: image.isCensored},attrs:{"src":image.src,"alt":image.title}})}),0),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }